export const DescriptionIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="10"
    viewBox="0 0 17 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line x1="0.5" y1="1" x2="16.5" y2="1" stroke="black" strokeWidth="2" />
    <line x1="0.5" y1="5" x2="16.5" y2="5" stroke="black" strokeWidth="2" />
    <line x1="0.5" y1="9" x2="11.5" y2="9" stroke="black" strokeWidth="2" />
  </svg>
);
